import styled from 'styled-components'

import { ToolTip } from 'app/components/design-system-components/Tooltip'
import * as Form from 'app/components/forms/forms'

type Props = {
  id: string
  label: string
  tooltipText: JSX.Element
  checked: boolean
  onChange: () => void
  disabled?: boolean
  showDisabledGrey?: boolean
}

const StyledToolTip = styled(ToolTip)`
  span {
    color: white !important;
  }
`

export default function CheckboxWithTooltip({
  id,
  label,
  tooltipText,
  checked,
  onChange,
  disabled = false,
  showDisabledGrey = false,
}: Props) {
  return (
    <Form.CheckBoxGeneral
      id={id}
      label={label}
      checked={checked}
      onChange={onChange}
      toolTip={(<StyledToolTip toolTipID={id} content={tooltipText} />) as any} // CheckBoxGeneral is not typed and initialises as a string, any fixes linting
      componentClassName="mt10"
      eventProcessedByComponent
      disabled={disabled}
      showDisabledGrey={showDisabledGrey}
    />
  )
}
